export default __webpack_public_path__ + "b0ab7c284d42a581e72399c3c67e95f7.png";